import withNavigate from '../../../core/withNavigate';
import { ShelfSegments } from '../../../components/segments/segments';
import { isClientSegment, isModernoStoreType } from './segments';

/**
 * Mimesa's Segmentaciones: Mimesa segments the moderno channel by client, so the generic
 * moderno store types (Nacional, Regional, Independiente) are hidden. Moderno segments that are
 * clients, and every tradicional type, stay.
 */
export class MimesaSegmentsPage extends ShelfSegments {
    visibleStoreTypes(storeTypes) {
        return storeTypes.filter((storeType) => !isModernoStoreType(storeType) || isClientSegment(storeType));
    }
}

export default withNavigate(MimesaSegmentsPage);
